import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierUnionIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 8H18.9C18.1 3.4 14.2 0 9.5 0C4.8 0 0 4.3 0 9.5C0 14.7 3.4 18.1 8 18.9V23C8 23.6 8.4 24 9 24H23C23.6 24 24 23.6 24 23V9C24 8.4 23.6 8 23 8ZM22 22H10V18C10 17.5 9.6 17 9.1 17C5.1 16.8 2 13.5 2 9.5C2 5.5 5.4 2 9.5 2C13.6 2 16.7 5.1 17 9.1C17 9.6 17.5 10 18 10H22V22Z"
        fill={color}
      />
      <path
        d="M15 11H13V9C13 8.4 12.6 8 12 8C11.4 8 11 8.4 11 9V11H9C8.4 11 8 11.4 8 12C8 12.6 8.4 13 9 13H11V15C11 15.6 11.4 16 12 16C12.6 16 13 15.6 13 15V13H15C15.6 13 16 12.6 16 12C16 11.4 15.6 11 15 11Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierUnionIcon.displayName = 'HierUnionIcon';
